import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Button, DashboardModule, Grid,
} from '@domain-group/suit-theme'

import useImage from '@hooks/useImage'
import useImages from '@hooks/useImages'

import UserImage from './UserImage'

interface UserImagesProps {
  userId: number,
}

const UserImages = (props: UserImagesProps) => {
  const { userId } = props

  const imagePayload = useImage({
    imageable_type: 'User',
    imageable_id: userId,
    image_type: 'photo',
  })

  const {
    callbacks: {
      createOrEditImage,
    },
  } = imagePayload

  const imagesPayload = useImages({
    filters: {
      imageable_id: userId,
      imageable_type: 'User',
    },
    performHttpRequests: !!userId,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredImages,
    filteredImagesCount,
    hasFilteredImages,
    loading,
  } = imagesPayload

  return (
    <DashboardModule contentBoxProps={{ flexDirection: 'column' }} loading={loading} title="Images">
      {hasFilteredImages && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection padding="large">
          <Grid
            // @ts-expect-error TS2322
            gridAutoRows="1fr"
            gridColumnGap="medium"
            gridRowGap="medium"
            gridTemplateColumns="repeat(auto-fill, minmax(100px, 1fr))"
            gridTemplateRows="repeat(auto-fill, minmax(100px, 1fr))"
          >
            {filteredImages.map(image => (
              <UserImage image={image} key={image.id} />
            ))}
          </Grid>
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: hasFilteredImages ? '1px solid' : 'none' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredImagesCount}
        // @ts-expect-error TS2322
        hideResultsText={canLoadMore}
        loading={loading}
      >
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditImage()}
            // @ts-expect-error TS2322
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Image
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.LoadMoreFooter>
    </DashboardModule>
  )
}

export default UserImages
